<div class="checkbox">
    <input type="checkbox" id="checkbox-{{ id }}" [disabled]="disable" [(ngModel)]="value" />
    <label for="checkbox-{{ id }}" aria-hidden="true"></label>
</div>
